import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  bpCode: "",
  bpName: "",
  postingDate: dayjs(dayjs()).format("YYYY-MM-DD"),
  docDate: "",
  toCustomer: "",
  toCustomerCode: "",
  customerAddress: "",
  vehicleNo: "",
  transporterName: "",
  invoiceNo: "",
  lrNo: "",
  remarks: "",
  lob: "",
  items: [],
  documentNo: "", // ✅ Add this field

};

const transferOutSlice = createSlice({
  name: "transferOutStore",
  initialState: initialState,
  reducers: {
    updateData: (state, action) => {
      return { ...state, ...action.payload };
    },
    updateItems: (state, action) => {
      state.items = action.payload.Items;
    },
    updateDocumentNo: (state, action) => { 
      state.documentNo = action.payload.documentNo; // ✅ Update document number
    },
    setRemarks: (state, action) => { 
      state.remarks = action.payload; // ✅ Store remarks in Redux
    },
    resetData: () => {
      return initialState;
    },
  },
});

export const { updateData, updateItems, updateDocumentNo, setRemarks, resetData } = transferOutSlice.actions;
export default transferOutSlice.reducer;
